import React, { useEffect, useState, useRef } from "react";
// Chakra imports
import {
    Box,
    Button,
    Flex,
    Icon,
    Spacer,
    Text,
    useColorModeValue,
    FormControl,
    FormLabel,
    Select,
    Input,
    Progress,
    Switch,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
} from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa";
import { Separator } from "components/Separator/Separator";
// react icons
// import SearchProduct from "./SearchProduct";
import SearchProductWithStocks from "./SearchProductWithStocks";

/**
 * serviceData = {
 *      ...service,
 *      addedProducts = [
 *          {
 *              ...product,
 *              quantity?
 *          }
 *      ]
 * }
 * 
 */
function CustomizeService({
    serviceData,
    onDataUpdated,
    onDelete,
}) {
    const textColor = useColorModeValue("gray.700", "white");

    // const [ addedProducts, setAddedProducts ] = useState([]);
    const [ errors, setErrors ] = useState([]);
    let addedProducts = [];

    useEffect(() => {
        if (serviceData) {
            const tmp = serviceData.completeProducts.map(product => {
                return {
                    id: product.id,
                    name: product.name,
                    sku: product.sku,
                    price: 0,
                    quantity: 1,
                    carMake: product.carMake,
                    carType: product.carType,
                    carYear: product.carYear,
                    carPart: product.carPart,
                }
            });

            // console.log(serviceData);
            // setAddedProducts(tmp);
            addedProducts = tmp;
            // console.log('addedProducts');
            // console.log(addedProducts);
        }

    }, [serviceData]);

    /// this throws an infinite rerender
    /// fix it by calling onUpdate each action 
    /// except the useEffect(() =>{[serviceData]})
    // useEffect(() => {
    //     onUpdate();
    // }, [addedProducts]);


    const onProductClicked = (product) => {
        setErrors([]);

        // console.log(product);
        if (product.stocks.length == 0) {
            setErrors(["Cannot add empty stock!"]);
            return;
        }

        if (!serviceData.products.includes(product.id)) {
            const tmp = [...serviceData.addedProducts];
            tmp.push({
                id: product.id,
                name: product.name,
                description: product.description,
                price: 0,
                quantity: 1,
                carMake: product.carMake,
                carType: product.carType,
                carYear: product.carYear,
                carPart: product.carPart,
                stocks: product.stocks,
                addedStocks: product.stocks.map((ps) => {return {
                    id: ps.id,
                    supplier: ps.supplier, 
                    available: ps.quantity,
                    unitPrice: ps.unitPrice,
                    sellingPrice: ps.sellingPrice,
                    quantity: 0,
                    price: ps.sellingPrice, 
                }}), 
            });
            addedProducts = tmp;
            // setAddedProducts(tmp);
            onUpdate();
        }
    }

    const removedAddedProduct = (product) => {

        const tmp = [...serviceData.addedProducts];

        const newTmp = [];
        tmp.forEach((p, index) => {
            if (p.id != product.id) {
                newTmp.push(p);
            }
        });

        addedProducts = newTmp;
        // setAddedProducts(newTmp);
        onUpdate();
    }

    const onQuantityChanged = (productId, stockId, quantity) => {
        const tmp = [...serviceData.addedProducts];

        tmp.forEach((product, index) => {
            if (productId == product.id ) {
                // tmp[index].quantity = quantity;
                product.addedStocks.forEach((stock, stockIndex) => {
                    if (stockId == stock.id) {
                        tmp[index].addedStocks[stockIndex].quantity = quantity > stock.available ? stock.available : quantity;
                    }
                });
            }
        });

        addedProducts = tmp;
        // setAddedProducts(tmp);
        onUpdate();
    }


    const onPriceChanged = (productId, stockId, price) => {
        const tmp = [...serviceData.addedProducts];

        tmp.forEach((product, index) => {
            if (productId == product.id) {
                // tmp[index].price = price;   
                product.addedStocks.forEach((stock, stockIndex) => {
                    if (stockId == stock.id) {
                        tmp[index].addedStocks[stockIndex].price = price;
                    }
                });
            }
        });
        addedProducts = tmp;

        // setAddedProducts(tmp);
        onUpdate();
    }

    const onUpdate = () => {
        const tmp = { ...serviceData };
        tmp.addedProducts = [
            ...addedProducts
        ];
        tmp.products = addedProducts.map(ap => ap.id);
        onDataUpdated(tmp);
    }


    return (
        <Box borderWidth="1px" p={4} >
            <Flex flexDirection="column" w="100%">
                <Flex flexDirection="row" w="100%">
                    <Text 
                    fontSize="lg"
                    color={textColor}
                    fontWeight="bold"
                    pb=".5rem"
                    flexGrow="1"
                    >
                    { serviceData.title } (₱{serviceData.discountedPrice > 0 
                                        ? Number(serviceData.discountedPrice).toLocaleString() 
                                        : Number(serviceData.price).toLocaleString()})
                    </Text>
                    <Button p="0px" bg="transparent" onClick={() => onDelete(serviceData)}>
                        <Flex color="red" cursor="pointer" align="center">
                            <Icon as={FaTrash} me="4px" />
                        </Flex>
                    </Button>
                </Flex>
                

                {/* Added Products */}
                <FormControl marginBottom="12px">
                    <Text fontSize="xs" color="gray.400" fontWeight="bold">
                        ITEMS INCLUDED
                    </Text>
                    { serviceData.addedProducts.length > 0 
                        ?  <Flex flexDirection="column" w="100%">
                            { serviceData.addedProducts.map((op, opIndex) => {
                                return <Box key={`addedproducts-${opIndex}`}>
                                    <Flex flexDirection="column" 
                                        w="100%" 
                                        align={"right"} 
                                        mt={"4px"}
                                        >
                                        <Text fontSize="xs" >
                                            {op.name} 
                                            { op.carMake 
                                                ? ` (${op.carMake} ${op.carType} ${op.carYear}, Part No: ${op.carPart})`
                                                : ""
                                            }
                                        </Text>
                                        <Text fontSize="xs" >
                                            &nbsp;&nbsp;&nbsp;&nbsp;{op.description} 
                                        </Text>

                                        <Button
                                            fontSize="8px"
                                            size="xs"
                                            colorScheme="red" variant="ghost"
                                            key={`added-prods-remove-${serviceData.id}-${op.id}`}
                                            onClick={() => removedAddedProduct(op)}
                                            >
                                            remove
                                        </Button>
                                    </Flex>
                                    <Flex flexDirection="row" 
                                        w="100%" 
                                        align={"center"} 
                                        mt={"4px"}
                                        >
                                        <Text 
                                            fontSize="xs" 
                                            pl={"32px"}
                                            // color="gray.400" 
                                            key={`added-stocks-current-${serviceData.id}-${op.id}`}
                                            >
                                            Available Stocks: {
                                                op.stocks && op.stocks.length > 0
                                                ? op.stocks.map(item => item.quantity).reduce((prev, next) => prev + next)
                                                : "0"
                                            } 
                                        </Text>
                                    </Flex>
                                    <Table variant="simple" color={textColor} ml={"32px"} width={"95%"}>
                                        <Thead>
                                            <Tr my=".8rem" p="0px" pr={"32px"}>
                                                <Th p="0px" color="gray.400" fontSize={8}>Supplier</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Available</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Unit Price</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Selling Price</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Qty</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Price</Th>
                                                <Th p="0px" color="gray.400" fontSize={8}>Total</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                        { op.addedStocks 
                                            ? op.addedStocks.map((st) => {
                                            return <Tr key={`st-${st.id}`} 
                                                flexDirection="row" 
                                                w="100%" 
                                                align={"center"} 
                                                mt={"4px"}
                                                pl={"32px"}
                                                >
                                                <Td p="0px" fontSize={9}>{st.supplier}</Td>
                                                <Td p="0px" fontSize={9}>{st.available}</Td>
                                                <Td p="0px" fontSize={9}>₱{Number(st.unitPrice).toLocaleString()}</Td>
                                                <Td p="0px" fontSize={9}>₱{Number(st.sellingPrice).toLocaleString()}</Td>
                                                <Td p="0px" fontSize={9}><Input
                                                        borderRadius="0"
                                                        mb="6px"
                                                        fontSize="xs"
                                                        type="number"
                                                        placeholder="Qty"
                                                        size="xs" 
                                                        width={"40px"}
                                                        height={"18px"}
                                                        min={0}
                                                        max={st.available}
                                                        value={st.quantity} 
                                                        onChange={e => onQuantityChanged(op.id, st.id, parseInt(e.target.value))}
                                                        // onChange={e => {
                                                        //     const abs = Math.abs(e.target.value);
                                                        //     const max = op.stocks && op.stocks.length > 0 
                                                        //         ? op.stocks.map(item => item.quantity).reduce((prev, next) => prev + next)
                                                        //         : 0;
                                                        //     // console.log(e.target.value, abs, parseInt(abs, 10));
                                                        //     if (abs > max) {
                                                        //         onQuantityChanged(op.id, max);
                                                        //     } else {
                                                        //         // const tmp = parseInt(abs) * 1;
                                                        //         onQuantityChanged(op.id, parseInt(e.target.value, 10));
                                                        //     }
                                                        // }}
                                                    />    
                                                </Td>
                                                <Td p="0px" fontSize={9}><Input
                                                        borderRadius="0"
                                                        mb="6px"
                                                        fontSize="xs"
                                                        type="number"
                                                        placeholder="Price"
                                                        size="xs" 
                                                        width={"80px"}
                                                        height={"18px"}
                                                        min={0}
                                                        value={st.price} 
                                                        onChange={e => onPriceChanged(op.id, st.id, parseFloat(e.target.value))}
                                                        // onChange={e => {
                                                        //     // const abs = Math.abs(e.target.value);
                                                        //     onPriceChanged(op.id, parseFloat(e.target.value));
                                                        // }}
                                                    />    
                                                </Td>
                                                <Td p="0px" fontSize={9}>
                                                    ₱{parseInt(st.quantity) * parseFloat(st.price)}
                                                </Td>
                                            </Tr>
                                        })
                                        : null }
                                        </Tbody>
                                    </Table>
                                    {/* <Flex flexDirection="column" 
                                        w="100%" 
                                        mt={"4px"}
                                        pl={"32px"}>
                                        { op.stocks.map((st) => {
                                            return <Flex key={`st-${st.id}`} 
                                                flexDirection="row" 
                                                w="100%" 
                                                align={"center"} 
                                                mt={"4px"}
                                                pl={"32px"}
                                                >
                                                <Box 
                                                    className="row" 
                                                    key={`added-prods-quantity-${serviceData.id}-${op.id}`}
                                                    >
                                                    <Flex direction={"row"} align={"center"}>
                                                        Qty <Input
                                                            key={`${serviceData.id}-qty-${op.id}`}
                                                            borderRadius="0"
                                                            mb="6px"
                                                            fontSize="xs"
                                                            type="number"
                                                            placeholder="Qty"
                                                            size="xs" 
                                                            width={"40px"}
                                                            height={"18px"}
                                                            min={0}
                                                            max={st.quantity}
                                                            // value={op.quantity} 
                                                            // onChange={e => {
                                                            //     const abs = Math.abs(e.target.value);
                                                            //     const max = op.stocks && op.stocks.length > 0 
                                                            //         ? op.stocks.map(item => item.quantity).reduce((prev, next) => prev + next)
                                                            //         : 0;
                                                            //     // console.log(e.target.value, abs, parseInt(abs, 10));
                                                            //     if (abs > max) {
                                                            //         onQuantityChanged(op.id, max);
                                                            //     } else {
                                                            //         // const tmp = parseInt(abs) * 1;
                                                            //         onQuantityChanged(op.id, parseInt(e.target.value, 10));
                                                            //     }
                                                            // }}
                                                        />    
                                                        &nbsp;x&nbsp; 
                                                        Price <Input
                                                            key={`${serviceData.id}-price-${op.id}`}
                                                            borderRadius="0"
                                                            mb="6px"
                                                            fontSize="xs"
                                                            type="number"
                                                            placeholder="Price"
                                                            size="xs" 
                                                            width={"80px"}
                                                            height={"18px"}
                                                            min={0}
                                                            // value={op.price} 
                                                            // onChange={e => {
                                                            //     // const abs = Math.abs(e.target.value);
                                                            //     onPriceChanged(op.id, parseFloat(e.target.value));
                                                            // }}
                                                        />    
                                                        <Text 
                                                            key={`${serviceData.id}-txt-${op.id}`}
                                                            ml={"4px"}
                                                            >
                                                            {"  =  "} (₱{op.price * op.quantity }){" "}
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                                <Button
                                                    fontSize="8px"
                                                    size="xs"
                                                    colorScheme="red" variant="ghost"
                                                    key={`added-prods-remove-${serviceData.id}-${op.id}`}
                                                    onClick={() => removedAddedProduct(op)}
                                                    >
                                                    remove
                                                </Button>
                                            </Flex>
                                        })
                                        }
                                    </Flex> */}
                                <Separator />
                                </Box>
                            })}
                        </Flex>
                        : <Text>-</Text>
                    }
                </FormControl>
                


                <Flex w="100%" flexDir="column">
                    { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                </Flex>
                
                <SearchProductWithStocks 
                    onClickProduct={onProductClicked}
                />

                <Spacer />

            </Flex>
        </Box>
    );
}


export default CustomizeService;